import TasksAPI from '../../api/tasksApi';
import types from '../mutation-types';

export const state = {
  dueToday: 0,
  overdue: 0,
};

export const getters = {
  getBadgeCount($state) {
    return $state.dueToday + $state.overdue;
  },
};

export const actions = {
  get: async function getMyTaskStats({ commit }, assignedToId) {
    try {
      const response = await TasksAPI.stats({ assigned_to_id: assignedToId });
      commit(types.SET_TASK_STATS, response.data);
    } catch (error) {
      // Ignore errors so the sidebar can continue rendering without the badge.
    }
  },
};

export const mutations = {
  [types.SET_TASK_STATS]($state, payload = {}) {
    $state.dueToday = payload.due_today || 0;
    $state.overdue = payload.overdue || 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
